import { render, staticRenderFns } from "./DeliveryApp.vue?vue&type=template&id=ebc2afac&scoped=true&"
import script from "./DeliveryApp.vue?vue&type=script&lang=js&"
export * from "./DeliveryApp.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryApp.vue?vue&type=style&index=0&id=ebc2afac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc2afac",
  null
  
)

export default component.exports